import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { CenterItem } from '../../../components/common'
import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import { ReactComponent as ExclamationIcon } from '../../../assets/gui/exclamation_60.svg'
import { signOut } from '../../../api/auth'

function NotSignUpModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const dismiss = async () => {
    await signOut()
    // navigate('/home', { replace: true })
    closeModal(MODALS_ID.NOT_SIGNUP)
  }

  return (
    <Modal id={MODALS_ID.NOT_SIGNUP} onClose={dismiss}>
      <CenterItem $direction="column" $gap={16}>
        <ExclamationIcon />
        <Text size={16} weight={500} lineHeight={24} block={true} $textAlign="center">
          현재는 회원가입이 불가능해요.
        </Text>
      </CenterItem>
      <Modal.Footer>
        <Button block={true} onClick={dismiss}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default NotSignUpModal
